import { useState } from 'react'
import TelegramSettings from '../../components/settings/TelegramSettings'
import ProfileSettings from '../../components/settings/ProfileSettings'
import SubscriptionSettings from '../../components/settings/SubscriptionSettings'
import NotificationSettings from '../../components/settings/NotificationSettings'

type Tab = 'profile' | 'telegram' | 'subscription' | 'notifications'

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('profile')

  const tabs: { id: Tab; label: string; icon: string }[] = [
    { id: 'profile', label: 'Профиль', icon: '👤' },
    { id: 'telegram', label: 'Telegram', icon: '📱' },
    { id: 'subscription', label: 'Подписка', icon: '💳' },
    { id: 'notifications', label: 'Уведомления', icon: '🔔' },
  ]

  return (
    <div className="pt-14">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Настройки</h1>
        <p className="text-gray-600 mt-1">
          Управление аккаунтом и настройками
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Tabs Navigation */}
        <div className="md:w-64 flex-shrink-0">
          <nav className="card p-2 space-y-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span>{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="flex-1">
          {activeTab === 'profile' && <ProfileSettings />}
          {activeTab === 'telegram' && <TelegramSettings />}
          {activeTab === 'subscription' && <SubscriptionSettings />}
          {activeTab === 'notifications' && <NotificationSettings />}
        </div>
      </div>
    </div>
  )
}
